// client/hooks/index.ts
import "./navigation.js";
